import { Icons } from '@silverfort/sf-components';
import { BlockPage } from '../../routings/pages/BlockPage/BlockPage';
import blockPageImage from './Images/LogsBlockPage.png';

const topics = [
    'Track every authentication with detailed insights into IdP responses, Silverfort actions, and MFA outcomes.',
    'Centralize visibility across users, resources, and protocols, with no log correlation required.',
    'Detect anomalies and uncover risky authentications before they become incidents.'
];

export const LogsBlockPage = () => {
    return (
        <BlockPage
            leftContent={{
                title: 'Authentication Logs',
                image: blockPageImage
            }}
            rightContent={{
                icon: Icons.Doc,
                title: 'See Every Authentication in Full Context',
                description:
                    'Gain visibility into all authentication activity to understand what happened, why it happened, and how to act on it.',
                topics,
                accessLink: 'https://www.silverfort.com/ad-protection-signup/?utm_source=PQL&utm_content=main'
            }}
        />
    );
};
